import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import {ContactUSService} from "../../../api/contactus/contactus.service";
import { Title } from '@angular/platform-browser';
// import {ToasterService} from '../../toaster-service.service';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './contactus.html'
})

export class ContactUs implements OnInit {
    lists = [];
    i : number;
    id: string;


    constructor(private contactUSService: ContactUSService,
                private router: Router, private titleService : Title) {
    }

    ngOnInit() {
        this.titleService.setTitle("Contact us  | Phoenix Games");
        if (localStorage.getItem('token') && localStorage.getItem('role') == 'SUPERADMIN') {
            this.contactUSService.allList()
                .then(data => {
                    this.lists = data
                });
        } else {
            this.router.navigate(['/']);
        }
    }

    deleteconfirmation(id, i) {
        //alert(JSON.stringify(keydata))
        this.i = i;
        this.id = id;
    }
    cancelAction(){
        this.i = null;
        this.id = "";
    }

    deletecontactus(){

        this.contactUSService.dcontactus(this.id).then(data => {
            if (data.status) {
                this.lists.splice(this.i, 1);
                $.notify({
                    message: "Successfully Deleted"
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                this.cancelAction();
            }
        });
    }



}






// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/contactus/contactus.page.ts